/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InfoMessage
 */
export interface InfoMessage {
    /**
     * 
     * @type {string}
     * @memberof InfoMessage
     */
    processType: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoMessage
     */
    target: string | null;
    /**
     * 
     * @type {Date}
     * @memberof InfoMessage
     */
    infoTime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof InfoMessage
     */
    infoType: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoMessage
     */
    message: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoMessage
     */
    processTypeName: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoMessage
     */
    targetName: string | null;
    /**
     * 
     * @type {string}
     * @memberof InfoMessage
     */
    infoTypeName: string | null;
}

/**
 * Check if a given object implements the InfoMessage interface.
 */
export function instanceOfInfoMessage(value: object): value is InfoMessage {
    if (!('processType' in value) || value['processType'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('infoTime' in value) || value['infoTime'] === undefined) return false;
    if (!('infoType' in value) || value['infoType'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('processTypeName' in value) || value['processTypeName'] === undefined) return false;
    if (!('targetName' in value) || value['targetName'] === undefined) return false;
    if (!('infoTypeName' in value) || value['infoTypeName'] === undefined) return false;
    return true;
}

export function InfoMessageFromJSON(json: any): InfoMessage {
    return InfoMessageFromJSONTyped(json, false);
}

export function InfoMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfoMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'processType': json['process_type'],
        'target': json['target'],
        'infoTime': (json['info_time'] == null ? null : new Date(json['info_time'])),
        'infoType': json['info_type'],
        'message': json['message'],
        'processTypeName': json['process_type_name'],
        'targetName': json['target_name'],
        'infoTypeName': json['info_type_name'],
    };
}

export function InfoMessageToJSON(json: any): InfoMessage {
    return InfoMessageToJSONTyped(json, false);
}

export function InfoMessageToJSONTyped(value?: InfoMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'process_type': value['processType'],
        'target': value['target'],
        'info_time': value['infoTime'] == null ? value['infoTime'] : value['infoTime'].toISOString(),
        'info_type': value['infoType'],
        'message': value['message'],
        'process_type_name': value['processTypeName'],
        'target_name': value['targetName'],
        'info_type_name': value['infoTypeName'],
    };
}

